const omniIconsetTypes = ["interactive", "informative", "object", "brand", "app", "editor"];
async function resolveOmniIconset(group = "?") {
  switch (group) {
    case "interactive":
      return import("./iconset-interactive.js");
    case "informative":
      return import("./iconset-informative.js");
    case "object":
      return import("./iconset-object.js");
    case "brand":
      return import("./iconset-brand.js");
    case "app":
      return import("./iconset-app.js");
    case "editor":
      return import("./iconset-editor.js");
    default:
      throw new Error(`Unknown icon set "${group}"`);
  }
}
const resolveOmniIcon = resolveOmniIconset;
export {
  omniIconsetTypes,
  resolveOmniIcon,
  resolveOmniIconset
};
//# sourceMappingURL=omni-icon-resolver.js.map
